<template>
  <v-dialog v-model="open" persistent scrollable :max-width="600">
    <v-card>
      <v-card-title class="headline mb-5">
        <span>{{ $t('actions.undelete') }}</span>
        <v-btn icon
               @click.stop="close">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle>
        <p class="warming-text font-weight-medium">
          {{ message }}
        </p>
      </v-card-subtitle>
      <v-card-text>

        <v-list class="selected-entities-list ">
          <slot v-for="item in items"
                name="entityListItem"
                :item="item" />
        </v-list>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click.stop="close" :disabled="working">
          {{ $t('actions.cancel') }}
        </v-btn>
        <v-btn type="submit" tile color="primary" dark @click="confirm" :loading="working">
          {{ $t('actions.undelete') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'EntityConfirmUndeleteDialog',

  props: {
    text: {
      type: String,
      required: true,
    },
    textPlural: {
      type: String,
    },
  },
  data(){
    return {
     items: [],
      open:false,
      working: false,
    };
  },
  computed:{
    message(){
      if (this.items.length > 1 && this.textPlural){
        return this.textPlural;
      }
      return this.text;
    },
  },
  methods: {
    confirm() {
      if (this.working){
        return;
      }
      this.working = true;
      this.$emit('confirmedUndelete', this.items);
    },
    show(items){
      this.items = JSON.parse(JSON.stringify(items));
      this.working = false;
      this.open = true;
    },
    close(){
      this.working = false;
      this.open = false;
      this.items = [];
    },
  },
});
</script>

<style scoped>
.headline {
  display: flex;
  justify-content: space-between;
  background-color: var(--v-primary-base);
  color: #fff;
  font-weight: 400;
}

.selected-entities-list {
  max-height: 30em;
}
.warming-text{
  font-size: larger;
  margin-top: 2em;
  color: black;

}
</style>
